var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voucher-root"},[_c('iframe',{attrs:{"src":`${_vm.serverPath}/tools/comprobante-compra?buyorder=${_vm.$route.params.buyorder}`,"type":"application/pdf","title":"PDF in an i-Frame","frameborder":"0","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }